import { insertPublicLead } from './database';
import { notifyLeadByEmail } from './email';
import { trackEvent } from './analytics';
import { productLabel } from './contactForm';
import type { SupportedLocale } from './localization';

export type PublicLeadInput = {
  name: string;
  email: string;
  message: string;
  phone?: string;
  company?: string;
  productInterest?: string;
  budget?: string;
  source?: string;
  landingUrl?: string;
  locale?: string;
};

function composeMessage(input: PublicLeadInput): string {
  const locale: SupportedLocale = input.locale === 'en' ? 'en' : 'es';
  const product = input.productInterest
    ? locale === 'es'
      ? `Producto o servicio de interés: ${productLabel(input.productInterest, locale)}`
      : `Product or service of interest: ${productLabel(input.productInterest, locale)}`
    : '';
  return [product, input.message.trim()].filter(Boolean).join('\n\n');
}

export async function submitPublicLead(input: PublicLeadInput) {
  const locale = input.locale === 'en' ? 'en' : 'es';
  const lead = {
    name: input.name.trim(),
    email: input.email.trim(),
    phone: input.phone?.trim() || null,
    company: input.company?.trim() || null,
    message: composeMessage(input),
    budget: input.budget?.trim() || null,
    source: input.source || 'website',
    landing_url: input.landingUrl || null,
    locale,
    status: 'New',
    notes: null,
  };
  await insertPublicLead(lead);

  trackEvent('lead_captured', {
    source: lead.source || 'website',
    locale: lead.locale || 'es',
    product: input.productInterest || undefined,
  });

  await notifyLeadByEmail({
    locale,
    name: lead.name,
    email: lead.email,
    phone: lead.phone || undefined,
    company: lead.company || undefined,
    product: input.productInterest ? productLabel(input.productInterest, locale) : undefined,
    message: lead.message || '',
    budget: lead.budget || undefined,
    source: lead.source || undefined,
    landingUrl: lead.landing_url || undefined,
  }).catch(() => undefined);

  return lead;
}
